function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.getAttribute("data-min"));

    if (!isNaN(min) && value < min) {
      this.input.value = 0;
    }

    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

hoverIntent = (el, onOver, onOut) => {
  let x;
  let y;
  let pX;
  let pY;
  const h = {};
  let state = 0;
  let timer = 0;

  let options = {
    sensitivity: 7,
    interval: 100,
    timeout: 200,
    overClass: "hovered",
  };

  const delay = (e) => {
    if (timer) timer = clearTimeout(timer);
    state = 0;
    if (onOut) {
      return onOut.call(el, e);
    }
    el.classList.remove(options.overClass);
    return false;
  };

  const tracker = (e) => {
    x = e.clientX;
    y = e.clientY;
  };

  const compare = (e) => {
    if (timer) timer = clearTimeout(timer);
    if (Math.abs(pX - x) + Math.abs(pY - y) < options.sensitivity) {
      state = 1;
      if (onOver) {
        return onOver.call(el, e);
      }
      el.classList.add(options.overClass);
      return false;
    }
    pX = x;
    pY = y;
    timer = setTimeout(() => {
      compare(e);
    }, options.interval);
    return false;
  };

  // Public methods

  const dispatchOver = (e) => {
    if (timer) timer = clearTimeout(timer);
    el.removeEventListener("mousemove", tracker, false);

    if (state !== 1) {
      pX = e.clientX;
      pY = e.clientY;

      el.addEventListener("mousemove", tracker, false);

      timer = setTimeout(() => {
        compare(e);
      }, options.interval);
    }

    return this;
  };

  const dispatchOut = (e) => {
    if (timer) timer = clearTimeout(timer);
    el.removeEventListener("mousemove", tracker, false);

    if (state === 1) {
      timer = setTimeout(() => {
        delay(e);
      }, options.timeout);
    }

    return this;
  };

  if (el) {
    el.addEventListener("mouseover", dispatchOver, false);
    el.addEventListener("mouseout", dispatchOut, false);
  }

  h.options = (opt) => {
    options = { ...options, ...opt };
    return h;
  };

  h.remove = () => {
    if (!el) return;
    el.removeEventListener("mouseover", dispatchOver, false);
    el.removeEventListener("mouseout", dispatchOut, false);
  };

  return h;
};

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const toggle = this.querySelector(".js-read-more-toggle");

    toggle.addEventListener("click", () => {
      this.classList.toggle("read-more--clipped");
    });
  }
}

customElements.define("read-more", ReadMore);

class BlogCarousel {
  constructor() {
    this.listeners();
  }

  listeners() {
    let requestResponse;
    const carousels = document.querySelectorAll(".js-blog-carousel");

    carousels.forEach((el) => {
      const id = el.id;
      const blog = el.getAttribute("data-blog");
      const filter = el.getAttribute("data-blog-filter");
      const listTarget = el.querySelector(".js-blog-carousel-slider-list");

      if (!id || !blog || !filter || !listTarget) return;

      const url = `${blog}/tagged/${filter}?section_id=blog-carousel-articles`;

      fetch(url)
        .then((response) => {
          requestResponse = response;
          return response.text();
        })
        .then((text) => {
          if (!requestResponse.ok) {
            throw new Error(`${requestResponse.status}: ${text}`);
          }

          const listSource = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".js-blog-carousel-articles");

          if (!listSource) return;

          listTarget.innerHTML = listSource.innerHTML;

          document.dispatchEvent(
            new CustomEvent("blogCarouselSlider:ready", {
              detail: {
                id: id,
              },
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
}

new BlogCarousel();

if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval;
      this.endDate = this.getAttribute('data-end-date');
      this.endTime = this.getAttribute('data-end-time');
      this.days = this.querySelector('.js-countdown-timer-days');
      this.hours = this.querySelector('.js-countdown-timer-hours');
      this.minutes = this.querySelector('.js-countdown-timer-minutes');
      this.seconds = this.querySelector('.js-countdown-timer-seconds');
      this.listeners();
    }

    listeners() {
      if (!this.endDate) return;
      if (!this.endTime) this.endTime = '00:00'

      try {
        const parts = this.getAttribute('data-end-date').split('/');
        const day = parts[0];
        const month = parts[1];
        const year = parts[2];

        const endDateTime = new Date(`${year}-${month}-${day}T${this.endTime}`).getTime();

        this.interval = setInterval(() => {
          try {
            const now = new Date().getTime();
            const diff = endDateTime - now;
            
            if (diff <= 0) return clearInterval(this.interval);

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            this.days.textContent = String(days).padStart(2, '0');
            this.hours.textContent = String(hours).padStart(2, '0');
            this.minutes.textContent = String(minutes).padStart(2, '0');
            this.seconds.textContent = String(seconds).padStart(2, '0');
          } catch (error) {
            this.error(error);        
          }
        }, 1000);
      } catch (error) {
        this.error(error);        
      }
    }

    error(error) {
      console.error(error);
      clearInterval(this.interval);
      this.style.display = 'none';
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
